import { FormControlLabel, Switch } from "@mui/material";
import { message } from "antd";
import React, { useEffect, useRef, useState } from "react";
import Swal from "sweetalert2";
import { useDataLayerValue } from "../../../DataLayer/DataLayer";
import Layout from "../../../Layout";
import PropTypes from "prop-types";
import Logs from "../../../components/Logs";
import SwitchBar from "../../../components/Pages/SwitchBar";
import CustomHeaderTitle from "../../../components/constants/CustomHeaderTitle";
import Custom2StageForm from "../../../components/template/Componets/Custom2StageForm/Custom2StageForm";
import CustomComponent from "../../../components/template/Componets/Custom2StageForm/CustomComponent";
import CardForm from "../../../components/template/Componets/Custom2StageForm/CustomForm";
import Level3Card from "../../../components/template/Componets/DealCard/Level3Card";
import Level4Card from "../../../components/template/Componets/DealCard/Level4Card";
import PageSEO from "../../../components/template/Componets/PageSEO/PageSEO";
import {
  clearCache,
  uploadFile,
  uploadFileMobile,
} from "../../../utils/ApiCalls/Document";
import { IMAGE_TYPE } from "../../../constants/ImageConstant";
import { addlog } from "../../../utils/ApiCalls/Logs";
import { addMenuList } from "../../../utils/ApiCalls/MenuList";
import {
  createWebpage,
  deletePageComponents,
  deleteVlogPageComponents,
  getShips,
  getWebpage,
  updatePageComponents,
  updateVlogPageComponents,
  updateWebpage,
  checkWebpageSlug
} from "../../../utils/ApiCalls/WebPages";
import { checkFields } from "../../../utils/Validation/checkFields";
import { checkFormFields } from "../../../utils/Validation/checkFormFields";
import AllVersion from "./AllVersion";
import { useLocation, useNavigate } from "react-router-dom";
import { LOG_ACTIONS, LOG_TYPES } from "../../../utils/Constant/LogConstant";
import HeaderBread from "../../../components/HeaderBread";

const CustomTemplates = ({
  slug,
  attributes,
  page_type,
  webpage_slug,
  url,
  pageComponentEndpoint = "page-components",
  backRoute,
  backTitle,
}) => {
  const deleteComponents =
    pageComponentEndpoint === "vlog-page-components"
      ? deleteVlogPageComponents
      : deletePageComponents;
  const updateComponents =
    pageComponentEndpoint === "vlog-page-components"
      ? updateVlogPageComponents
      : updatePageComponents;
  const [activetab, setActiveTab] = useState("english");
  const [dataattributes, setDataattributes] = useState(attributes);
  const [active, setActive] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState();
  const [version, setVersion] = useState();
  const [refreshKey, setRefreshKey] = useState(0);
  const [error, setError] = useState([]);
  const [{ userDetails }, dispatch] = useDataLayerValue();
  const [pageData, setPageData] = useState({
    slug,
    location: [],
    component: [],
  });
  const [seoErrors, setSeoErrors] = useState({});
  const localIdRef = useRef(0);

  const makeLocalId = () =>
    `local-${Date.now()}-${(localIdRef.current += 1)}`;

  const ensureLocalId = (item) => {
    if (!item) return item;
    if (item.id || item.__localId) return item;
    return { ...item, __localId: makeLocalId() };
  };

  const handlePreview = (event) => {
    setActive(event.target.checked);
  };

  const handleChange = (index, data) => {
    setPageData((prevState) => {
      let arrayData = [...(prevState?.component || [])];

      if (index >= arrayData.length) {
        const missing = index - arrayData.length + 1;
        const placeholders = Array.from({ length: missing }, () => ({
          __localId: makeLocalId(),
        }));
        arrayData = [...arrayData, ...placeholders];
      }

      const existing = arrayData[index] || {};
      const localId = existing.__localId || data?.__localId;
      arrayData[index] = localId ? { ...data, __localId: localId } : data;

      return {
        ...prevState,
        component: arrayData,
      };
    });
  };

  const handleDelete = async (dataindex) => {
    setPageData((item) => ({
      ...item,
      component: item.component.filter((item, index) => index != dataindex),
    }));
    setDataattributes((item) => ({
      ...item,
      component: item.component.filter((item, index) => index != dataindex),
    }));
    if (pageData.component.find((item, index) => index == dataindex)?.id)
      await deleteComponents(
        pageData.component.find((item, index) => index == dataindex).id
      );

    getData(slug, {});
    // addData(1, true, {
    //   ...pageData,
    //   component: pageData.component.filter((item, index) => index != dataindex),
    // });
  };

  const handleUp = (index) => {
    if (index > 0) {
      setPageData((prevData) => {
        const val = [...prevData.component]; // Create a shallow copy of the array
        [val[index - 1], val[index]] = [val[index], val[index - 1]]; // Swap elements
        return { ...prevData, component: val };
      });
    }
  };

  const handleDown = (index) => {
    if (index < pageData.component.length - 1) {
      setPageData((prevData) => {
        const val = [...prevData.component]; // Create a shallow copy of the array
        [val[index], val[index + 1]] = [val[index + 1], val[index]]; // Swap elements
        return { ...prevData, component: val };
      });
    }
  };
  const fileKeys = [
    "image",
    "image1",
    "mobile_image",
    "mobile_image2",
    "image2",
    "image3",
    "image4",
    "image5",
    "arabic_image",
    "simplified_chinese_image",
    "traditional_chinese_image",
    "bahasa_image",
    "bahasa_image2",
    "bahasa_image_mobile",
    "popup_image",
    "simplified_chinese_popup_image",
    "traditional_chinese_popup_image",
    "english_file",
    "simplified_chinese_file",
    "traditional_chinese_file",
    "bahasa_file",
    "star_cruises_english_file",
    "star_cruises_simplified_chinese_file",
    "star_cruises_traditional_chinese_file",
    "star_cruises_bahasa_file",
    "arabic_file",
    "logo",
    "simplified_chinese_logo",
    "traditional_chinese_logo",
    "arabic_logo",
    "bahasa_logo",
    "english_file_1",
    "simplified_chinese_file_1",
    "traditional_chinese_file_1",
    "arabic_file_1",
    "bahasa_file_1",
    "english_file_2",
    "simplified_chinese_file_2",
    "traditional_chinese_file_2",
    "bahasa_file_2",
    "english_file_3",
    "simplified_chinese_file_3",
    "traditional_chinese_file_3",
    "bahasa_file_3",
    "arabic_file_2",
  ];
  // True if `fileName` is still used as a string value anywhere inside `node`.
  const containsFileRef = (node, fileName) => {
    if (typeof node === "string") return node === fileName;
    if (node && typeof node === "object")
      return Object.values(node).some((value) => containsFileRef(value, fileName));
    return false;
  };

  // `refRoots` is everything being saved. A copied section (plus icon) shares
  // the same S3 file as its source, so the old file is only sent for deletion
  // when nothing in `refRoots` still points at it.
  const uploadImagesRecursively = async (data, originalData = {}, refRoots = [data]) => {
    try {
      for (const key in data) {
        if (data[key] && typeof data[key] === "object") {
          for (const fileKey of fileKeys) {
            if (data[key][fileKey])
              if (
                data[key][fileKey] !== undefined &&
                data[key][fileKey] !== null
              ) {
                const previous = originalData[key]?.[fileKey];
                const oldValue =
                  typeof previous === "string" &&
                  typeof data[key][fileKey] !== "string" &&
                  !refRoots.some((root) => containsFileRef(root, previous))
                    ? previous
                    : null;
                const uploadedFile = await handleFileUpload(
                  data[key][fileKey],
                  fileKey,
                  oldValue
                );
                if (uploadedFile?.error) {
                  Swal.fire(uploadedFile.error);
                  data[key][fileKey] = "";
                } else {
                  data[key][fileKey] = uploadedFile;
                }
              } else {
                data[key][fileKey] = "";
              }
          }

          await uploadImagesRecursively(data[key], originalData[key] || {}, refRoots);
        }
      }
    } catch (e) {
      console.log(e);
      Swal.fire(e.message);
      throw e;
    }
  };

  const addField = (attributes) => {
    setDataattributes((item) => ({
      ...item,
      component: [...item.component, attributes],
    }));
    setPageData((prevState) => ({
      ...prevState,
      component: [...(prevState?.component || []), { __localId: makeLocalId() }],
    }));
  };

  const handleRefreshPage = () => {
    getData(slug);
    setRefreshKey(prev => prev + 1);
  };

  useEffect(() => {
    shipsData();
    if (slug) getData(slug);
  }, [slug, version]);

  const setLayout = (pageData) => {
    console.log({name:pageData.page_type})
    if (pageData && pageData.page_type === "blog_item" && dataattributes) {
      const componentCount = pageData.component.length;
      const dataCount = dataattributes.component.length;

      if (componentCount > dataCount) {
        const missingSections = componentCount - dataCount;
        const newSections = Array(missingSections).fill(
          attributes.component[attributes.component.length - 1]
        );
        setDataattributes((prev) => ({
          ...prev,
          component: [...prev.component, ...newSections],
        }));
      }
    }
  };
  async function handleFileUpload(selectedFile, fileKey, oldFileName = null) {
    if (typeof selectedFile === "string") {
      return selectedFile; // Return the string if it's already a URL
    } else {
      let real;
      if (fileKey?.toString()?.includes("file")) {
        real = "yes";
      }
      if (fileKey === "mobile_image" || fileKey === "mobile_image2") {
        let imageType = {
          type: IMAGE_TYPE.ENTERTAINMENT_MOBILE_IMAGE,
          subType: "",
        };
        const uploadedFile = await uploadFileMobile(
          selectedFile,
          imageType,
          real,
          false,
          oldFileName
        );
        if (uploadedFile?.error)
          return { error: uploadedFile.error || "Unable to upload image" };
        return uploadedFile?.url || "";
      }
      const uploadedFile = await uploadFile(selectedFile, {}, real, oldFileName);
      if (uploadedFile?.error) throw new Error(uploadedFile.error);
      return uploadedFile.url;
    }
  }
  const validateSEO = (data) => {
    let errors = {};
    if (page_type === "vlog_item" && !data?.component?.[0]?.brand) {
      errors.brand = "Please select a brand.";
    }
    if (page_type !== "blog_item" && !data?.title?.trim()) {
      errors.title = "English page title is required.";
    }
    if (page_type !== "blog_item" && !data?.description?.trim()) {
      errors.description = "English meta description is required.";
    }
    if (page_type === "blog_item" && !data?.id && !data?.title?.trim() && !data?.slug?.trim()) {
      errors.slug = "Slug is required when english page title is not provided.";
    }
    if (
      (page_type === "events_item" || page_type === "blog_item" || page_type === "vlog_item") &&
      (!data?.location || data.location.length === 0)
    ) {
      errors.location = "Display location is required.";
    }
    return errors;
  };
  const addData = async (componentindex, val) => {
    try {
      const seo_errors = validateSEO(pageData);
      setSeoErrors(seo_errors);

      if (Object.keys(seo_errors).length > 0) {
        message.error(
          page_type === "blog_item"
            ? "Slug is required"
            : "Some SEO fields are missing"
        );
        return;
      }
      if (page_type === "blog_item") {
        const thumbnailData = pageData?.component?.[0];
        const languageSections = {
          ENG: ["title", "image", "thumbnail_image_alt", "description"],
          SC: ["simplified_chinese_title", "simplified_chinese_image", "thumbnail_simplified_image_alt", "simplified_chinese_description"],
          TC: ["traditional_chinese_title", "traditional_chinese_image", "thumbnail_traditional_image_alt", "traditional_chinese_description"],
          BM: ["bahasa_title", "bahasa_image", "bahasa_thumbnail_image_alt", "bahasa_description"],
        };
        const tabToSection = { english: "ENG", simplified_chinese: "SC", treditonal_chinese: "TC", bahasa: "BM" };

        const isFilled = (v) => v !== "" && v !== null && v !== undefined;

        // At least one section must have content
        const hasAtLeastOneSection = Object.values(languageSections).some((keys) =>
          keys.some((key) => isFilled(thumbnailData?.[key]))
        );
        if (!hasAtLeastOneSection) {
          const activeSection = tabToSection[activetab] || "ENG";
          setError([languageSections[activeSection]]);
          message.error("Content is required before publishing.");
          return;
        }

        // If any field in a section is filled, all fields in that section are required
        for (const [lang, keys] of Object.entries(languageSections)) {
          const filledCount = keys.filter((key) => isFilled(thumbnailData?.[key])).length;
          if (filledCount > 0 && filledCount < keys.length) {
            const missingKeys = keys.filter((key) => !isFilled(thumbnailData?.[key]));
            setError([missingKeys]);
            message.error(`All ${lang} fields are required before publishing.`);
            return;
          }
        }
      }

      let checkValid = true;
      let errors = attributes.component.map((item, index) => {
        const componentData = pageData?.component?.[index];

        // Collect required field keys (always required)
        const requiredKeys =
          item?.fields
            ?.filter((field) => field.required)
            .map((field) => field.key) || [];

        // Collect conditionalRequired field keys (only required if parent has value)
        const conditionalKeys =
          item?.fields
            ?.filter((field) => {
              if (!field.conditionalRequired) return false;
              const parentValue = componentData?.[field.conditionalRequired];
              return (
                parentValue !== undefined &&
                parentValue !== null &&
                parentValue !== "" &&
                !(Array.isArray(parentValue) && parentValue.length === 0)
              );
            })
            .map((field) => field.key) || [];

        const urlKeys =
          item?.fields
            ?.filter((field) => {
              const isUrlField =
                field?.inputType === "url" ||
                field?.key?.toLowerCase().includes("url");
              if (!isUrlField) return false;
              const value = componentData?.[field.key];
              if (!value) return false;
              try {
                new URL(value);
                return false;
              } catch {
                return true;
              }
            })
            .map((field) => field.key) || [];

        // Merge both sets of keys to validate
        const allKeysToValidate = [...requiredKeys, ...conditionalKeys];

        let error = checkFormFields(componentData, allKeysToValidate);
        urlKeys.forEach((key) => {
          if (!error.includes(key)) error.push(key);
        });

        if (error.length > 0) {
          checkValid = false;
        }
        return error;
      });

      if (!checkValid) {
        message.error(page_type === "blog_item" ? "Content is required before publishing" : "Some fields are missing");
        setError(errors);
      } else {
        setError([]);
        dispatch({
          type: "SET_LOADING",
          loading: true,
        });
        let dataValues = val || pageData;
        await uploadImagesRecursively(dataValues, data || {});
        dataValues.slug =
          dataValues.slug ||
          slug ||
          dataValues?.title?.toLowerCase().replaceAll(" ", "-") + "-" + Math.floor(Math.random() * 90 + 10);
        const payload = {
          slug: dataValues.slug,
        };
        if (dataValues?.id) {
          payload.id = dataValues.id;
        }
        const response = await checkWebpageSlug(payload);
        if (!response?.success) {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response?.message || "Unknown error occurred",
          });
          dispatch({
            type: "SET_LOADING",
            loading: false,
          });
          setSeoErrors((prev) => ({
            ...prev,
            slug: response?.message,
          }));
          return;
        }
        dataValues.page_type = page_type || "deal";
        if (
          !["vlog_item", "blog_item"].includes(page_type) ||
          !pageData?.id
        ) {
          dataValues.is_active = 1;
        }       
        let valid = checkFields(dataValues);
        if (valid) {
          dispatch({
            type: "SET_ERROR_MESSAGE",
            errMess: { message: valid, type: "error" },
          });
          dispatch({
            type: "SET_LOADING",
            loading: false,
          });
        } else {
          const values = {
            ...dataValues,
          };
          let data;

          if (pageData?.id) {
            data = await updateWebpageData(pageData.id, values);
          } else {
            values.version_is_active = 0;
            data = await createWebpage(values);

            if (data?.message) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: data?.message || "Unknown error occurred",
              });
              dispatch({
                type: "SET_LOADING",
                loading: false,
              });
            } else {
              if (webpage_slug && !pageData?.id) {
                let data = {
                  url: url + "/" + dataValues.slug,
                  webpage_slug,
                  menuName: dataValues?.component?.[0]?.title,
                  traditionalChineseMenuName:
                    dataValues?.component?.[0]?.traditional_chinese_title,
                  simplifiedChineseMenuName:
                    dataValues?.component?.[0]?.simplified_chinese_title,
                  arabicMenuName: dataValues.arabicMenuName,
                  bahasaMenuName: dataValues?.component?.[0]?.bahasa_title
                };
                addMenuList(data);
              } 
              dispatch({
                type: "SET_LOADING",
                loading: false,
              });
            }
          }

          if (data?.error || data?.message) {
            dispatch({
              type: "SET_ERROR_MESSAGE",
              errMess: { message: data.error, type: "error" },
            });

            Swal.fire({
              icon: "error",
              title: "Oops...",
              text: data.message || "Unknown error occurred",
            });
            dispatch({
              type: "SET_LOADING",
              loading: false,
            });
            message.error(data?.message || "Webpage added");
          } else {
            setVersion(data?.webpageData?.version);
            addlog(
              pageData?.id ? LOG_ACTIONS.UPDATED : LOG_ACTIONS.CREATED,
              dataValues.slug || slug,
              { id: dataValues.id, title: dataValues?.title },
              userDetails.id
            );
            message.success(componentindex ? "Updated" : "Webpage updated");
            // if (!componentindex)
            //   addlog(
            //     "New webpage  Created",
            //     dataValues?.slug,
            //     { date: new Date() },
            //     userDetails.id
            //   );
          }
          const currentPath = location.pathname;

          if (!pageData?.id) {
            navigate(
              currentPath
                .split("/")
                .filter(
                  (item, index) => index != currentPath.split("/").length - 1
                )
                .join("/")
            );
          } else
            navigate(
              currentPath
                .split("/")
                .filter(
                  (item, index) => index != currentPath.split("/").length - 1
                )
                .join("/") +
              "/" +
              dataValues.slug
              , { replace: true });
          getData(dataValues.slug, val);
          dispatch({
            type: "SET_LOADING",
            loading: false,
          });
        }
      }
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: e,
      });
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };

  const clearData = async () => {
    let data = await clearCache();
    if (data) {
      message.success("Cache Referesh Started");
    }
  };
  const updateWebpageData = async (id, data) => {
    try {
      let { component, ...rest } = data;

      await updateWebpage(id, rest);

      await Promise.all(
        component.map(async (item, index) => {
          let value = {
            ...item,
            page_id: id,
            index,
            component_name: index.toString(), // Convert index to string
          };
          await updateComponents(value); // Await the updateSubComponent call
        })
      );
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: error.message || "Unknown error occurred",
      });
      console.error("Error updating webpage data:", error);
    }
  };

  const updateComponentData = async (values, index) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });

    let dataValues = {
      component: [
        {
          ...values,
           dataArray: (values.dataArray || []).map(item => ({
        ...item,
        status: item.hasOwnProperty("status") ? item.status : true,
      })),
          page_id: pageData.id,
          index,
          component_name: index.toString(),
        },
      ],
    };
    try {
      await uploadImagesRecursively(
        dataValues,
        { component: [data?.component?.[index] || {}] },
        [dataValues, ...(pageData?.component || []).filter((_, i) => i !== index)]
      );
      await updateComponents(dataValues.component[0]);
      message.success("updated");
      addlog(
        " Webpage  updated and Section " + (index + 2) + " updated",
        pageData?.slug || slug,
        { date: new Date() },
        userDetails.id
      );
      getData(slug);
      dispatch({
        type: "SET_LOADING",
        loading: false,
      });
    } catch (e) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: e,
      });
      message.error("failed to update");
    }
    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
    // }
  };

  const getData = async (slug, val) => {
    dispatch({
      type: "SET_LOADING",
      loading: true,
    });
    let data = await getWebpage({ slug: slug, version: version || "0" });

    if (!val) setLayout(data);
    const normalizedComponents = (data?.component || []).map((item) =>
      ensureLocalId(item)
    );
    setPageData({ ...data, component: normalizedComponents });
    setData(data);

    dispatch({
      type: "SET_LOADING",
      loading: false,
    });
  };
  const shipsData = async () => {
    let values = await getShips({ location_id: 1, menubarId: 2 });

    if (values.data) {
      dispatch({
        type: "SET_SHIPS",
        ships: values?.data?.map((item) => ({
          id: item?.url.replace("our-ship/", "").replaceAll("-", "_"),
          name: item?.menuName,
        })),
      });
    }
  };

  return (
    <div>
      <Layout key={slug} type={"create_per"} module_data={"webpages"} allow>
        <CustomHeaderTitle key={slug} slug={slug} title={slug} />
        {backRoute && (
          <HeaderBread
            title={backTitle || ""}
            navigation={[
              { title: "Home", route: "/" },
              { title: backTitle, route: backRoute },
              { title: slug ? "Edit" : "Add", route: "#" },
            ]}
          />
        )}
        <div>
          <section className="content">
            <div className="container-fluid">
              <SwitchBar
                tabs={[
                  { title: "English", value: "english" },
                  { title: "Simplified Chinese", value: "simplified_chinese" },
                  { title: "Traditional Chinese", value: "treditonal_chinese" },
                  { title: "Bahasa", value: "bahasa" },
                  { title: "Logs", value: "logs" },
                ]}
                activeTab={activetab}
                setActiveTab={setActiveTab}
              />
              {[
                "english",
                "simplified_chinese",
                "treditonal_chinese",
                "arabic",
                "bahasa",
              ].includes(activetab) && (
                <div className="input_form" onSubmit={() => {}}>
                  <div className="row">
                    <div className="col-lg-12">
                      <FormControlLabel
                        control={
                          <Switch checked={active} onChange={handlePreview} />
                        }
                        label="Preview All"
                      />

                      <PageSEO
                        webpage_slug={slug}
                        activetab={activetab}
                        page_id={data?.id}
                        cardData={pageData}
                        addData={addData}
                        setCardData={setPageData}
                        page_type={page_type}
                        errors={seoErrors}
                        setErrors={setSeoErrors}
                      />

                      {dataattributes.component.map((item, index) => {
                        const componentKey =
                          pageData?.component?.[index]?.id ||
                          pageData?.component?.[index]?.__localId ||
                          index;
                        return item.type === 1 ? (
                          <CardForm
                            attributes={item.fields}
                            rootData={pageData}
                            key={componentKey + ""}
                            page_id={data?.id}
                            oldData={data?.component?.[index]}
                            preview={active}
                            error={error?.[index]}
                            handleUp={handleUp}
                            handleDown={handleDown}
                            activetab={activetab}
                            cardData={pageData?.component?.[index] || {}}
                            updateComponentData={(data) =>
                              updateComponentData(data, index)
                            }
                            setCardData={(item) => {
                              handleChange(index, item);
                            }}
                            setError={(errs) => {
                              let newErrors = [...(error || [])];
                              newErrors[index] = errs;
                              setError(newErrors);
                            }}
                            reinitOnIdChangeOnly={page_type === "blog_item"}
                            customValidate={page_type === "blog_item" && index === 0 ? (cardData) => {
                              const languageSections = {
                                ENG: ["title", "image", "thumbnail_image_alt", "description"],
                                SC: ["simplified_chinese_title", "simplified_chinese_image", "thumbnail_simplified_image_alt", "simplified_chinese_description"],
                                TC: ["traditional_chinese_title", "traditional_chinese_image", "thumbnail_traditional_image_alt", "traditional_chinese_description"],
                                BM: ["bahasa_title", "bahasa_image", "bahasa_thumbnail_image_alt", "bahasa_description"],
                              };
                              const isFilled = (v) => v !== "" && v !== null && v !== undefined;
                              const hasAtLeastOneSection = Object.values(languageSections).some((keys) =>
                                keys.some((key) => isFilled(cardData?.[key]))
                              );
                              if (!hasAtLeastOneSection) {
                                return { keys: Object.values(languageSections).flat(), message: "Content is required before publishing." };
                              }
                              for (const [lang, keys] of Object.entries(languageSections)) {
                                const filledCount = keys.filter((key) => isFilled(cardData?.[key])).length;
                                if (filledCount > 0 && filledCount < keys.length) {
                                  return { keys: keys.filter((key) => !isFilled(cardData?.[key])), message: `All ${lang} fields are required before publishing.` };
                                }
                              }
                              return null;
                            } : undefined}
                          >
                            {item.preview(
                              activetab,
                              pageData?.component?.[index] || {},
                              pageData
                            )}
                          </CardForm>
                        ) : item.type === 2 ? (
                          <Custom2StageForm
                            level2={item.level1}
                            key={componentKey + ""}
                            page_id={data?.id}
                            rootData={pageData}
                            handleUp={handleUp}
                            handleDown={handleDown}
                            updateComponentData={(data) =>
                              updateComponentData(data, index)
                            }
                            error={error?.[index]}
                            level1={item.fields}
                            oldData={data?.component?.[index]}
                            preview={active}
                            dataCard={
                              pageData?.component?.[index] || { dataArray: [] }
                            }
                            setDataCard={(item) => {
                              handleChange(index, item);
                            }}
                            activetab={activetab}
                            reverseOrder={item.reverseOrder}
                            groupBy={item.groupBy}
                          >
                            {item.preview(
                              activetab,
                              pageData?.component?.[index] || {},
                              pageData
                            )}
                          </Custom2StageForm>
                        ) : item.type === 3 ? (
                          <Level3Card
                            level2={item.level2}
                            level1={item.level1}
                            page_id={data?.id}
                            updateComponentData={(data) =>
                              updateComponentData(data, index)
                            }
                            handleUp={handleUp}
                            handleDown={handleDown}
                            key={componentKey + ""}
                            rootData={pageData}
                            oldData={data?.component?.[index]}
                            preview={active}
                            fields={item.fields}
                            error={error?.[index]}
                            dataCard={
                              pageData?.component?.[index] || { dataArray: [] }
                            }
                            setDataCard={(item) => {
                              handleChange(index, item);
                            }}
                            activetab={activetab}
                            slug = {pageData.slug}
                          >
                            {item.preview(
                              activetab,
                              pageData?.component?.[index] || {},
                              pageData
                            )}
                          </Level3Card>
                        ) : item.type === 4 ? (
                          item.component(
                            data?.component?.[index],
                            active,
                            pageData?.component?.[index],
                            (item) => {
                              handleChange(index, item);
                            },
                            activetab,
                            item
                          )
                        ) : item.type === 5 ? (
                          <CustomComponent
                            item={item}
                            index={index}
                            key={`${componentKey}-${refreshKey}`}
                            page_id={data?.id}
                            updateComponentData={(data) =>
                              updateComponentData(data, index)
                            }
                            handleDelete={handleDelete}
                            show={index === dataattributes.component.length - 1}
                            attributes={item.fields}
                            handleUp={handleUp}
                            handleDown={handleDown}
                            rootData={pageData}
                            oldData={data?.component?.[index]}
                            preview={active}
                            error={error?.[index]}
                            activetab={activetab}
                            addField={addField}
                            cardData={pageData?.component?.[index] || {}}
                            setCardData={(item) => {
                              handleChange(index, item);
                            }}
                            onRefreshPage={handleRefreshPage}
                          >
                            {item.preview(
                              activetab,
                              pageData?.component?.[index] || {},
                              pageData
                            )}
                          </CustomComponent>
                        ) : item.type === 6 ? (
                          <Level4Card
                            level2={item.level2}
                            level1={item.level1}
                            level3={item.level3}
                            page_id={data?.id}
                            updateComponentData={(data) =>
                              updateComponentData(data, index)
                            }
                            key={componentKey + ""}
                            rootData={pageData}
                            oldData={data?.component?.[index]}
                            preview={active}
                            handleUp={handleUp}
                            handleDown={handleDown}
                            fields={item.fields}
                            error={error?.[index]}
                            dataCard={
                              pageData?.component?.[index] || { dataArray: [] }
                            }
                            setDataCard={(item) => {
                              handleChange(index, item);
                            }}
                            activetab={activetab}
                          >
                            {item.preview(
                              activetab,
                              pageData?.component?.[index] || {},
                              pageData
                            )}
                          </Level4Card>
                        ) : (
                          <div key={index + ""}></div>
                        );
                      })}

                      <div
                        className="text-right"
                        style={{ marginBottom: "10px" }}
                      >
                        {slug == "brochures-guides" && (
                          <button
                            onClick={() => clearData()}
                            className="btn main_submit"
                            style={{ marginRight: "10px" }}
                          >
                            Clear Cache
                          </button>
                        )}

                        {!data?.id && (
                          <button
                            onClick={() => addData()}
                            className="btn main_submit"
                          >
                            Add Page
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {slug && activetab == "version" && (
                <AllVersion
                  slug={slug}
                  version={version}
                  setVersion={setVersion}
                  setActiveTab={setActiveTab}
                />
              )}
              {slug && activetab === "logs" && <Logs hidetitle type={slug} />}
            </div>
          </section>
        </div>
      </Layout>
    </div>
  );
};
CustomTemplates.propTypes = {
  slug: PropTypes.any,
  attributes: PropTypes.any,
  page_type: PropTypes.any,
  webpage_slug: PropTypes.any,
  url: PropTypes.any,
};
export default CustomTemplates;
